import ListColumnModel from '@/modules/base/model/list-column-model'
import { caseInsensitiveComparator } from '@/modules/base/components/list/comparator'
import { CLIENT_CONNECTION_STATUS, getConnectionStatusLabel } from '@/modules/client/_helpers/getStatusLabel'
import { getCompanyFormGroupLabelByCompanyForm } from '../create/company'
import COMPANY_FORMS, { CONNECTION_TYPE_OFFLINE, CONNECTION_TYPE_ONLINE } from '@/modules/client/constants'

export default class ClientListColumnModel extends ListColumnModel {
  constructor(data) {
    super(data)
    this.displayed = data.displayed
    this.hide = data.hide || false
    this.setColumnSpecificProperties()
  }

  setColumnSpecificProperties() {
    switch (this.name) {

      case 'name': {
        this.comparator = caseInsensitiveComparator
        break
      }

      case 'email': {
        this.comparator = caseInsensitiveComparator
        this.cellRenderer = 'userCellRenderer'
        break
      }

      case 'clientNumber': {
        this.comparator = caseInsensitiveComparator
        break
      }

      case 'companyAddress': {
        this.valueFormatter = (params) => {
          return params.value
        }
        break
      }

      case 'connectionStatus': {
        this.cellRenderer = 'connectionStateRenderer'
        this.valueFormatter = (params) => {
          return getConnectionStatusLabel(params.value)
        }
        this.filter = 'agSetColumnFilter'
        this.filterParams = {
          values: [...Object.values(CLIENT_CONNECTION_STATUS)],
          valueFormatter: (params) => {
            return getConnectionStatusLabel(params.value)
          },
        }
        break
      }

      case 'clerks': {
        this.cellRenderer = 'userCellRenderer'
        break
      }

      case 'contactUser': {
        this.comparator = caseInsensitiveComparator
        this.cellRenderer = 'userCellRenderer'
        break
      }

      case 'companyForm': {
        this.valueFormatter = (params) => {
          return getCompanyFormGroupLabelByCompanyForm(params.value)
        }
        this.filter = 'agSetColumnFilter'
        this.filterParams = {
          values: [...(Object.values(COMPANY_FORMS).filter((form) => ![CONNECTION_TYPE_ONLINE, CONNECTION_TYPE_OFFLINE].includes(form)))],
          valueFormatter: (params) => {
            return getCompanyFormGroupLabelByCompanyForm(params.value)
          },
        }
        break
      }

      default: { return }
    }
  }
}
